import { Navigate, useOutletContext } from 'react-router-dom';
import { needsOnboarding } from '../lib/customer-status.js';
import { onboardingPath } from '../lib/lifecycle-notice.js';
import { landingRoute } from '../lib/navigation.js';
import NoAccess from './NoAccess.jsx';

/**
 * "/" (portal workbench landing rules): the first page the user can use,
 * never a page whose only purpose is a button. A customer admin whose
 * deployment is not finished goes straight to the onboarding wizard, as
 * before; anyone without a usable scope gets the no-access page.
 */
export default function Landing() {
  const { me, impersonating, navClaims } = useOutletContext();
  const own = me?.customer;
  // Operators always start on the fleet, even when /me carries a customer record.
  if (!impersonating && navClaims.isOperator !== true && navClaims.admin === true && own?.customerId === navClaims.customerId && needsOnboarding(own)) {
    return <Navigate to={onboardingPath(navClaims.customerId)} replace />;
  }
  const to = landingRoute(navClaims);
  return to ? <Navigate to={to} replace /> : <NoAccess staff={me?.user?.isStaff === true} />;
}
